import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { CmsMappedArticlesInterface } from '~/src/repositories/cms/types/cms.articles.types';
import type { RelatedArticlesInterface } from '~/src/repositories/cms/entities/main/types/cms.related-articles.types';

export const getMappedRelatedArticlesData = (
    data: Array<CmsMappedArticlesInterface | Record<string, never>>,
): RelatedArticlesInterface[] => {
    return (Array.isArray(data) ? data : [data])
        .reduce<RelatedArticlesInterface[]>((relatedArticleItem, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const relatedArticleList = elem.attributeCategories.potentsialnaya_pribyl?.attributes;
                relatedArticleItem.push({
                    id: elem.id,
                    name: elem?.name || null,
                    productDescription: relatedArticleList?.product_description?.value || null,
                    image: relatedArticleList?.image?.value || null,
                    order: elem?.order || fallBackOrder,
                    sefUrl: elem?.sefUrl || null,
                });
            }
            return relatedArticleItem;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
